import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-working" }
const _hoisted_2 = { class: "v-working__header" }
const _hoisted_3 = { class: "v-working__badge" }
const _hoisted_4 = { class: "v-working__actions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "v-working__form" }
const _hoisted_7 = { class: "v-working__form" }

import { computed, onMounted, ref, watch } from "vue";
import { useNotification } from "@/utils/notification";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import { useWorkTypeStore } from "@/features/work-types/work-type.store";
import { IWorkType } from "@/features/work-types/work-type.types";
import { Pencil02, SearchMd, Plus } from "utruckin-icons";
import CustomTab from "@/components/custom/CustomTab.vue";
import { useAppStore } from "@/store/app.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkingView',
  setup(__props) {

const workTypeStore = useWorkTypeStore();
const appStore = useAppStore();
const { pushNotification } = useNotification();

const loading = ref(false);
const workTypes = ref<IWorkType[]>([]);
const search = ref<string>("");
const editTouched = ref(false);
const activeTab = ref<number>(1);
let searchTimer: ReturnType<typeof setTimeout> | null = null;

const priorityItems = [
  { value: "LOW", name: "Low" },
  { value: "NORM", name: "Norm" },
  { value: "HIGH", name: "High" },
  { value: "URGENT", name: "Urgent" },
];

const tabs = [
  { label: "All", value: 0 },
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

// ─── ADD MODAL ───────────────────────────────────────────
const addModal = ref(false);
const addLoading = ref(false);
const addForm = ref({
  name: "",
  description: "",
  base_points: 0,
  complexity_multiplier: 1,
  default_sla_minutes: 0,
  default_priority: "",
  is_active: true,
});

const openAddModal = () => {
  addForm.value = {
    name: "",
    description: "",
    base_points: 0,
    complexity_multiplier: 1,
    default_sla_minutes: 0,
    default_priority: "",
    is_active: true,
  };
  addModal.value = true;
};

const submitAdd = async () => {
  await workTypeStore.createWorkType(
    addLoading,
    addForm.value,
    async (data: any) => {
      if (data) {
        pushNotification("Successfully saved", "success");
        workTypes.value = await workTypeStore.getWorkTypes(loading);

        addModal.value = false;
      }
    }
  );
};

// ─── EDIT MODAL ──────────────────────────────────────────
const editModal = ref(false);
const editLoading = ref(false);
const editWorkTypeId = ref<string>("");
const editForm = ref({
  description: "",
  base_points: 0,
  complexity_multiplier: 1,
  default_sla_minutes: 0,
  default_priority: "",
  is_active: true,
});

// Валидация edit формы

const isEditFormValid = computed(
  () =>
    String(editForm.value.base_points).trim() !== "" &&
    String(editForm.value.default_sla_minutes).trim() !== ""
);

const editBasePointsError = computed(
  () => editTouched.value && String(editForm.value.base_points).trim() === ""
);

const editMinutesError = computed(
  () =>
    editTouched.value &&
    String(editForm.value.default_sla_minutes).trim() === ""
);

const openEditModal = (item: IWorkType) => {
  editTouched.value = false;
  editWorkTypeId.value = item.id;
  editForm.value = {
    description: item.description,
    base_points: item.base_points,
    complexity_multiplier: item.complexity_multiplier,
    default_sla_minutes: item.default_sla_minutes,
    default_priority: item.default_priority,
    is_active: item.is_active,
  };
  editModal.value = true;
};

const submitEdit = async () => {
  editTouched.value = true;
  if (!isEditFormValid.value) return;
  const payload = {
    description: editForm.value.description,
    base_points: Number(editForm.value.base_points),
    complexity_multiplier: Number(editForm.value.complexity_multiplier),
    default_sla_minutes: Number(editForm.value.default_sla_minutes),
    default_priority: editForm.value.default_priority,
    is_active: editForm.value.is_active,
  };
  const result = await workTypeStore.updateWorkType(
    editLoading,
    payload,
    editWorkTypeId.value
  );
  if (result) {
    pushNotification("Successfully saved", "success");
    workTypes.value = await workTypeStore.getWorkTypes(loading);
    editModal.value = false;
  }
};

const getList = async () => {
  workTypes.value = await workTypeStore.getWorkTypes(loading, true);
};

onMounted(async () => {
  await getList();

  if (workTypeStore.commonFilter?.search) {
    search.value = workTypeStore.commonFilter.search;
  }
  if (workTypeStore.commonFilter?.is_active == null) {
    activeTab.value = 0;
  } else if (workTypeStore.commonFilter?.is_active == true) {
    activeTab.value = 1;
  } else {
    activeTab.value = 2;
  }
});

watch(
  () => activeTab.value,
  async (newVal) => {
    if (workTypeStore.commonFilter) {
      if (newVal == 0) {
        workTypeStore.commonFilter.is_active = null;
      } else workTypeStore.commonFilter.is_active = newVal == 1;

      await getList();
    }
  }
);

watch(
  () => search.value,
  async (val) => {
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      if (workTypeStore.commonFilter) {
        workTypeStore.commonFilter.search = val;
        await getList();
      }
    }, 400);
  }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: "Search",
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CustomTab, {
        tabs: tabs,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(CommonButton, {
        type: "primary",
        label: "Add working",
        prepend: true,
        prependIcon: _unref(Plus),
        onClicked: openAddModal
      }, null, 8, ["prependIcon"])
    ]),
    _createVNode(CommonTable, {
      headers: _unref(workTypeStore).workTypeHeaders,
      items: workTypes.value,
      loading: loading.value
    }, {
      id: _withCtx(({ index }) => [
        _createElementVNode("span", null, _toDisplayString(index + 1), 1)
      ]),
      title: _withCtx(({ item }) => [
        _createElementVNode("span", null, _toDisplayString(item.name), 1)
      ]),
      base_points: _withCtx(({ item }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.base_points), 1)
      ]),
      complete_minutes: _withCtx(({ item }) => [
        _createElementVNode("span", null, _toDisplayString(item.default_sla_minutes + " minutes"), 1)
      ]),
      priority: _withCtx(({ item }) => [
        _createElementVNode("span", null, _toDisplayString(item.default_priority), 1)
      ]),
      status: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["status", item.is_active ? 'active' : 'inactive'])
        }, _toDisplayString(item.is_active ? "active" : "inactive"), 3)
      ]),
      actions: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "v-working__btn",
            onClick: ($event: any) => (openEditModal(item))
          }, [
            _createVNode(_unref(Pencil02), { size: 18 })
          ], 8, _hoisted_5)
        ])
      ]),
      _: 1
    }, 8, ["headers", "items", "loading"]),
    _createVNode(CommonModal, {
      modelValue: addModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addModal).value = $event)),
      title: "Add working"
    }, {
      footer: _withCtx(() => [
        _createVNode(CommonButton, {
          type: "outline",
          label: "Cancel",
          onClicked: _cache[7] || (_cache[7] = ($event: any) => (addModal.value = false))
        }),
        _createVNode(CommonButton, {
          type: "primary",
          label: "Save",
          loading: addLoading.value,
          onClicked: submitAdd
        }, null, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CommonInput, {
            modelValue: addForm.value.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addForm.value.name) = $event)),
            label: "Name"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            modelValue: addForm.value.description,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addForm.value.description) = $event)),
            label: "Description"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            modelValue: addForm.value.base_points,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addForm.value.base_points) = $event)),
            modelModifiers: { number: true },
            label: "Base points",
            type: "number"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            modelValue: addForm.value.default_sla_minutes,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addForm.value.default_sla_minutes) = $event)),
            modelModifiers: { number: true },
            label: "Complete minutes",
            type: "number"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonDropdown, {
            modelValue: addForm.value.default_priority,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addForm.value.default_priority) = $event)),
            items: priorityItems,
            label: "Priority"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: editModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editModal).value = $event)),
      title: "Edit working"
    }, {
      footer: _withCtx(() => [
        _createVNode(CommonButton, {
          type: "outline",
          label: "Cancel",
          onClicked: _cache[13] || (_cache[13] = ($event: any) => (editModal.value = false))
        }),
        _createVNode(CommonButton, {
          type: "primary",
          label: "Save",
          loading: editLoading.value,
          onClicked: submitEdit
        }, null, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(CommonInput, {
            modelValue: editForm.value.description,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.description) = $event)),
            label: "Description"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            modelValue: editForm.value.base_points,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.base_points) = $event)),
            modelModifiers: { number: true },
            label: "Base points",
            type: "number",
            error: editBasePointsError.value,
            errorMessage: "Base points is required"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(CommonInput, {
            modelValue: editForm.value.default_sla_minutes,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.default_sla_minutes) = $event)),
            modelModifiers: { number: true },
            label: "Complete minutes",
            type: "number",
            error: editMinutesError.value,
            errorMessage: "Complete minutes is required"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(CommonDropdown, {
            modelValue: editForm.value.default_priority,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editForm.value.default_priority) = $event)),
            items: priorityItems,
            label: "Priority"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})